import { CommonService } from "../../../../../services/CommonService";
import Availability from "../../components/Availability";
import { order } from "../SmartSearchParammeter";

export default async function AvailabilitySearchCofig(key) {
  let availabilities = await CommonService.getAvailabilities();

  return {
    operation: ["Must"],
    list: availabilities.map((a) => a.description.replace(/,/g, "#").trim()),
    description: "Availability",
    id: "availabilityStatusId",
    initial: [],
    type: order.fourth,
    handleValues: (searchObject) => {
      return;
    },
    Component: (searchObject, setSearchObject, onChange, t) => (
      <div className="col-6 mt-2">
        <Availability
          searchObject={searchObject}
          setSearchObject={setSearchObject}
          onChange={onChange}
          t={t}
        />
      </div>
    ),
    handler: function (searchObj, value) {
      searchObj["availabilityStatusId"] = availabilities
        .filter((a) => value[0] == a.description.replace(/#/g, ",").trim())
        .map((a) => a.id)
        .shift();
    }
  };
}
